<template>
  <Layout>
    <Content :style="{'padding': '10px'}">
      <Breadcrumb :style="{margin: '5px 0'}">
        <BreadcrumbItem>素材管理 > <b>任务列表</b></BreadcrumbItem>
      </Breadcrumb>
      <Card>
		  <span class="search_span_width">
			  <span class="search_span_width_part1">状态：</span>
			  <Select v-model="search.status" style="width:200px">
			          <Option value="-1">编辑中</Option>
			          <Option value="1">人物生成中</Option>
			          <Option value="2">人物生成成功</Option>
					  <Option value="3">人物生成失败</Option>
					  <Option value="7">素材匹配中</Option>
			      </Select>
			<span class="search_span_width_part1">创建时间：</span>
			  <DatePicker type="daterange" v-model="search.created_at"  format="yyyy/MM/dd" placement="bottom-end" placeholder="选择日期" style="width: 200px"></DatePicker>
		  </span>
		  <Button type='primary' icon="ios-search" :style="{'margin-left':'20px'}" @click="getTaskList(1)">搜索</Button>
        <Card id="tableContent" >
          <Table :columns="tableColumns" :data="task_list"></Table>
		   <Page :total="task_total" :current="current_page" :page-size="20" @on-change="getTaskList" show-elevator />
        </Card>
      </Card>
    </Content>
  </Layout>
</template>
<script>
export default {
  data(){
    return {
		task_list:[],
		task_total:0,
		current_page:1,
		loading1: false,
		options1: [],
		search:{
			id:0,
			status:0,
			created_at:[]
		},
		tableColumns:[
		{ title: '任务ID', key: 'id', align: 'center' },
		{ title: '用户ID', key: 'user_id', align: 'center' },
		{ title: '直播间ID', key: 'studio_id', align: 'center' },
		{ title: '模板ID', key: 'template_id', align: 'center' },
		{ title: '标题', key: 'title', align: 'center' },
		{ title: '素材数量', key: 'material', align: 'center'},
		{ title: '素材数量', key: 'status', align: 'center',
			render : (h, params) => {
				let status_name = '';
				if (params.row.status==7) {
					status_name = '素材匹配';
				} else if (params.row.status == 0) {
					status_name = '编辑中';
				} else if (params.row.status == 1) {
					status_name = '人物生成中';
				} else if (params.row.status == 2) {
					status_name = '人物生成成功';
				} else if (params.row.status == 3) {
					status_name = '人物生成失败';
				}
				return h('span',status_name);
			}
		},
		{ title: '操作', key: 'action', align: 'center',
		  render: (h, params) => {
			let btns=[]
			btns.push(
				h('Button', {
				  props: { type: 'warning', size: 'small' },
				  style: { marginRight: '5px', marginBottom: '5px'},
				  on: {
					click: () => {      
						this.$router.push('/script/taskContent?task_id=' + params.row.id);
					}
				  }
				}, '编辑'),
			);
			return h("div",btns);
		  }
		}
		]
	}
  },
  mounted:function(){
    this.getTaskList(1);
  },
  computed:{

  },
  methods:{
	searchTitle(query){
	  if (query !== '') {
		  this.loading1 = true;
		  setTimeout(() => {
			  this.loading1 = false;
			  this.http.get('/admin/material/scriptSearch',{params:{keyword:query}}).then(response=>{
				let data=response.data;
				if(data.code!==0){
				alert(data.message);
				} else{
					this.options1 = data.data.list;
				}
			  }).catch(()=>{
				this.$Message.error('网络错误');
			  });
		  }, 500);
	  } else {
		  this.options1 = [];
	  }
	  
	},
	getTaskList(page) {
		this.current_page = page;
		let params = Object.assign(this.search);
		params['page'] = page;
		this.http.get('/admin/material/scriptTasklist',{params:params}).then(response=>{
		  let data=response.data;
		  if(data.code!==0){
			alert(data.message);
		  } else{
			this.task_list = data.data.list;
			this.task_total = data.data.total;
		  }
		}).catch(()=>{
		  this.$Message.error('网络错误');
		});
	},
    closeModal(){
		this.showmodal=false;
    }
  }

}
</script>
